import {merge} from 'lodash';
import Assessment from '../assessment';
import AssessmentResult from '../../../values/AssessmentResult';
import {FAQS_POINTS, FAQs_STRUCTURE_DATA_ID} from '@axyseo/const/analysis';

/**
 * Represents an assessment that checks FAQs content and structure for SGE optimization.
 */
export default class FAQsStructureDataAssessment extends Assessment {
  /**
   * Sets the identifier and the config.
   *
   * @param {Object} [config] The configuration to use.
   *
   * @returns {void}
   */
  constructor(config = {}) {
    super();

    const defaultConfig = {
      id: FAQs_STRUCTURE_DATA_ID,
      ctaType: 'contactUs',
      docUrl: 'https://blog.google/products/search/generative-ai-search/',
      priority: 'high',
      fixPosition: 'faqs',
      title: 'FAQs structured data',
      content: {
        good: 'FAQ structured data added',
        improve: '',
        bad: 'Add FAQs structured data for Google rich results eligibility.',
      }
    };

    this.identifier = FAQs_STRUCTURE_DATA_ID;
    this._config = merge(defaultConfig, config);
  }

  /**
   * Executes the Assessment and returns a result.
   *
   * @param {Paper}       paper       The Paper object to assess.
   * @param {Researcher}  researcher  The Researcher object containing all available researches.
   *
   * @returns {AssessmentResult} The result of the assessment, containing both a score and a descriptive text.
   */
  getResult({paper, researcher}) {
    const calculatedResult = this.calculateResult(paper);
    const assessmentResult = new AssessmentResult({config: this._config});
    assessmentResult.setScore(calculatedResult.score);
    assessmentResult.setStatus(calculatedResult.status);
    return assessmentResult;
  }

  /**
   *
   * @param paper
   * @returns {{score: number, status: string, data: {hasSchema: ((function(): *)|boolean), hasProperStructure: boolean, hasMinimumFAQs: boolean}}|{score: number, status: string, data: {hasFAQs: boolean}}}
   */
  calculateResult(paper) {
    let status = 'bad'
    const hasSchema = paper.hasFAQsSchema();
    if (hasSchema) {
      status = 'good';
    }
    return {
      score: this.getScore(FAQS_POINTS, status) || 0,
      status
    };
  }




  isApplicable(paper) {
    return true;
  }
}
